import { ReplicaTransportError } from './replica-transport'
export type WorkerCallError = {
  deleted?: boolean
  status?: number
  code?: string
  cause?: WorkerCallError
  error?: WorkerCallError
  suppressed?: WorkerCallError
  errors?: WorkerCallError[]
  message: string
  name: string
  stack?: string
}
export function serializeWorkerError(error: unknown): WorkerCallError {
  if (!(error instanceof Error))
    return { message: String(error), name: 'Error' }
  return {
    cause: error.cause ? serializeWorkerError(error.cause) : undefined,
    message: error.message,
    name: error.name,
    stack: error.stack,
    ...('code' in error && typeof error.code === 'string' ? { code: error.code } : {}),
    ...(error.name === 'SuppressedError' && 'error' in error && 'suppressed' in error ? { error: serializeWorkerError(error.error), suppressed: serializeWorkerError(error.suppressed) } : {}),
    ...(error instanceof AggregateError ? { errors: error.errors.map(serializeWorkerError) } : {}),
    ...(error.name === 'ReplicaTransportError' ? { status: (error as Error & { status: number }).status, code: (error as Error & { code?: string }).code, deleted: (error as Error & { deleted?: boolean }).deleted } : {}),
  }
}

export function deserializeWorkerError(error: WorkerCallError): Error {
  const cause = error.cause ? deserializeWorkerError(error.cause) : undefined
  const result = error.name === 'ReplicaTransportError' && typeof error.status === 'number'
    ? new ReplicaTransportError(error.status, error.code, error.message, cause, error.deleted === true)
    : error.name === 'SuppressedError' && error.error && error.suppressed
      ? new SuppressedError(deserializeWorkerError(error.error), deserializeWorkerError(error.suppressed), error.message)
      : error.errors
        ? new AggregateError(error.errors.map(deserializeWorkerError), error.message, { cause })
        : new Error(error.message, { cause })
  if (error.code !== undefined) Object.assign(result, { code: error.code })
  result.name = error.name
  if (error.stack) result.stack = error.stack
  return result
}
